import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hideNavigation", "children"];
import styled, { css } from 'styled-components';
import { Small } from 'foundations-components/transitional/components/Small';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEXT_AREA_HEIGHT = 160;

/* stolen from popover.private-tooltip--longform */
export const tooltipBorder = css(["border-radius:3px;box-shadow:0 1px 24px 0 rgb(0 0 0 / 8%);background-color:", ";border:1px solid ", ";"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['border-core-default']);

/* when the popover is displayed in a side panel in an iframe,
the 500px width pushes the right side of the box off the screen
the contextual workflow side panel is the standard width of 460px
plus 6px to display the shadow
*/
export const LargeWrapper = styled.div.withConfig({
  displayName: "SharedStyleComponents__LargeWrapper",
  componentId: "sc-1lknomm-0"
})(["width:500px;height:250px;max-height:250px;display:flex;flex-direction:column;align-items:center;&{", "}@media screen and (max-width:466px){width:402px;}"], tooltipBorder);
export const GreyContainer = _ref => {
  let {
      hideNavigation,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    justifyContent: hideNavigation ? 'end' : 'space-between',
    alignItems: "center",
    padding: "300",
    backgroundColor: "fill-surface-raised",
    inlineSize: "100%"
  }, props, {
    children: children
  }));
};
export const PopoverHeader = ({
  label,
  body,
  onCancel
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "fill-surface-raised",
    inlineSize: "100%",
    padding: "300",
    children: [/*#__PURE__*/_jsxs(Flex, {
      inlineSize: "100%",
      paddingInlineStart: "100",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "div",
          typography: "heading-100",
          children: label
        }), body && /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: body
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        alignSelf: "center",
        marginInline: "200",
        children: /*#__PURE__*/_jsx(AIBadge, {})
      })]
    }), /*#__PURE__*/_jsx(CloseButton, {
      position: "static",
      color: "icon-core-subtle",
      "data-test-id": "close",
      size: "large",
      marginInlineEnd: "100",
      onClick: onCancel
    })]
  });
};